import { useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { testConnectionAction } from 'routes/api';
import { Connection, ConnectionConfiguration } from 'shared/types/ObjectTypes';

// Runs one of the Connection's actions with the values on screen (or the saved
// ones) and keeps the answer for the panel to show.
export function useConnectionTestAction(
  connection: Connection,
  // Whatever useKeycloakToken holds; only a live string token runs a test.
  token: unknown,
) {
  const { keycloak } = useKeycloak();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<any>(null);

  const run = async (
    action_id: string,
    action_type: string,
    formData?: Record<string, unknown>,
  ) => {
    if (token && typeof token === 'string' && !keycloak.isTokenExpired()) {
      setLoading(true);
      const stored = connection.configurations.find(
        (a: ConnectionConfiguration) => a.action.id === action_id,
      );
      const form_data = formData ?? stored?.data ?? {};
      try {
        let result = await testConnectionAction(
          token,
          connection.id,
          action_type,
          { config_overrides: Object(form_data) },
        );
        if (result) {
          setResponse(result.data);
        }
      } catch (err: any) {
        setResponse({
          error:
            err?.response?.data?.detail ||
            err?.message ||
            'Server error. Please try again.',
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return { run, loading, response };
}
